import { create } from "zustand";

// Глобальний стор (state manager) для модального вікна підтвердження
export const useConfirmationStore = create((set, get) => ({
  isVisible: false,
  title: "",
  message: "",
  onConfirm: () => {}, // коллбек, при підтвердженні

  // Показує вікно підтвердження
  showConfirmation: ({ title, message, onConfirm }) => {
    set({
      isVisible: true,
      title,
      message,
      onConfirm,
    });
  },

  // Приховує вікно підтвердження
  hideConfirmation: () => {
    set({
      isVisible: false,
      title: "",
      message: "",
      onConfirm: () => {},
    });
  },

  // Обробник для кнопки "Так"
  handleConfirm: () => {
    get().onConfirm(); // Виконуємо збережений коллбек
    get().hideConfirmation(); // Приховуємо вікно
  },
}));
